import { defineMessages } from 'react-intl';

const messages = defineMessages({
  audio: {
    id: 'Audio',
    defaultMessage: 'Audio',
  },
  audioURL: {
    id: 'Audio URL',
    defaultMessage: 'Audio URL',
  },
  audioURLDescription: {
    id: 'Audio URL Description',
    defaultMessage: 'Select an internal audio file',
  },
});

export const schemaAudio = ({ intl }) => {
  return {
    required: [],
    fieldsets: [
      {
        id: 'default',
        title: intl.formatMessage(messages.audio),
        fields: ['url'],
      },
    ],
    properties: {
      url: {
        title: intl.formatMessage(messages.audioURL),
        description: intl.formatMessage(messages.audioURLDescription),
        widget: 'object_browser',
        mode: 'link',
        allowExternals: false,
        selectedItemAttrs: [
          'Title',
          'Description',
          '@type',
          'audio_file',
          'file',
        ],
        selectableTypes: ['Audio', 'File'],
      },
    },
  };
};

export default schemaAudio;
